var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterfaceEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "grid"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M12,23C5.935,23,1,18.065,1,12S5.935,1,12,1   s11,4.935,11,11S18.065,23,12,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.766,5.268c-0.472-0.473-1.244-0.474-1.718,0L6.925,14.39c0,0,0,0-0.001,0.001l-0.002,0.002   c-0.058,0.058-0.093,0.127-0.117,0.2c-0.003,0.008-0.01,0.013-0.012,0.021l-0.753,2.731c-0.048,0.173,0.002,0.359,0.129,0.486   c0.095,0.095,0.223,0.146,0.354,0.146c0.044,0,0.089-0.006,0.133-0.018l2.73-0.753c0.008-0.002,0.013-0.01,0.022-0.013   c0.074-0.024,0.143-0.06,0.199-0.116l9.125-9.125c0.229-0.229,0.355-0.535,0.355-0.859c0-0.324-0.126-0.629-0.355-0.858   L17.766,5.268z M7.239,16.761l0.291-1.054l0.381,0.381l0.381,0.382L7.239,16.761z M9.254,16.017l-0.635-0.635l-0.635-0.635   l7.935-7.935l1.27,1.271L9.254,16.017z M18.025,7.245l-0.13,0.13l-1.27-1.271l0.13-0.13c0.083-0.083,0.219-0.084,0.304,0   l0.967,0.968c0.055,0.054,0.063,0.118,0.063,0.151C18.088,7.126,18.08,7.19,18.025,7.245z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceEdit);
export default __webpack_public_path__ + "static/media/interface_edit.e42ccd89.svg";
export { ForwardRef as ReactComponent };